import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';

const SupportForm = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [loading, setLoading] = useState(true);
  const handleFormReady = () => setLoading(false);
  useEffect(() => {
    setLoading(true);
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/5027593.js';
    script.defer = true;
    document.body.appendChild(script);

    window.addEventListener('hs-form-event:on-ready', handleFormReady);

    return () => {
      document.body.removeChild(script);
      window.removeEventListener('hs-form-event:on-ready', handleFormReady);
    };
  }, []);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ textAlign: 'center' }}>
        {loading && <CircularProgress />}
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="e58d3e41-aec4-4323-a5b2-9e1760298936"
          data-portal-id="5027593"
        />
      </DialogContent>
    </Dialog>
  );
};

export default SupportForm;
